<bb-collapsible-card-ui>
  <span bbCollapsibleTitle>Click me</span>
  <div bbCollapsibleBody>I am expandable content!</div>
</bb-collapsible-card-ui>
